<!--字段配置Ec-->
<template>
  <div class="field-main">
    <div class="field-menu">
      <span>{{originType}}-crm(数据接收方)</span>
      <span>招商智投(数据发送方)</span>
    </div>
    <el-collapse @change="handleChange">
      <el-collapse-item v-for="(item,index) in formFiled" :key="index" :title="item.crmFName" :name="index">
        <el-form label-width="200px" label-position="left" :model="formFiled" ref="formFiled" @keyup.enter.native="submitForm('formFiled')">
          <!--判断是否有子选项-->
          <template v-if="item.crmHasChild">
            <el-form-item v-for="(v,i) in item.crmChildDataList" :label="v.crmFName" :prop="v.crmFCode" :key="i">
              <el-select v-model="v.wyFieldData.wyFCode" clearable placeholder="请选择" @change="changSelect($event, index, i)">
                <el-option v-for="(k,j) in optionsField" :key="j" :label="k.name" :value="k.code"></el-option>
              </el-select>
              <template v-if="v.wyFieldData.wyFCode == 'itemTitle'">
                <el-select v-model="v.wyFieldData.wyFChildCode" clearable placeholder="请选择" @change="changeItemSelect($event,index,i)">
                  <el-option v-for="(k,j) in itemSelect" :key="j" :label="k.title" :value="k.id + ''"></el-option>
                </el-select>
              </template>
              <!-- <template v-if="v.wyFieldData.wyFCode == 'channel'">
                <el-select v-model="v.wyFieldData.wyFChildCode" clearable placeholder="请选择" @change="changeItemSelect($event,index,i)">
                  <el-option v-for="(k,j) in channelSelect" :key="j" :label="k.title" :value="k.id + ''"></el-option>
                </el-select>
              </template> -->
              <!-- <template v-if="v.wyFieldData.wyFCode == 'resType'">
                <el-select v-model="v.wyFieldData.wyFChildCode" clearable placeholder="请选择" @change="changeItemSelect($event,index,i)">
                  <el-option v-for="(k,j) in typeList" :key="j" :label="k.name" :value="k.id + ''"></el-option>
                </el-select>
              </template> -->
              <template v-if="v.wyFieldData.wyFCode == 'noSelect'">
                <el-checkbox class="default" v-model="v.wyFieldData.wyDefaultBooleanValue">设为默认</el-checkbox>
              </template>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item v-for="(v,i) in item.wyFieldDataList" label="" :prop="v.wyFCode" :key="i">
              <el-select v-model="v.wyFCode" clearable placeholder="请选择" @change="changSelect($event, index, i)">
                <el-option v-for="(k,j) in optionsField" :key="j" :label="k.name" :value="k.code"></el-option>
              </el-select>
              <template v-if="v.wyFCode == 'itemTitle'">
                <el-select v-model="v.wyFChildCode" clearable placeholder="请选择" @change="changeItemSelect($event,index,i)">
                  <el-option v-for="(k,j) in itemSelect" :key="j" :label="k.title" :value="k.id + ''"></el-option>
                </el-select>
              </template>
              <!-- <template v-if="v.wyFCode == 'channel'">
                <el-select v-model="v.wyFChildCode" clearable placeholder="请选择" @change="changeItemSelect($event,index,i)">
                  <el-option v-for="(k,j) in channelSelect" :key="j" :label="k.title" :value="k.id + ''"></el-option>
                </el-select>
              </template> -->
              <!-- <template v-if="v.wyFCode == 'resType'">
                <el-select v-model="v.wyFChildCode" clearable placeholder="请选择" @change="changeItemSelect($event,index,i)">
                  <el-option v-for="(k,j) in typeList" :key="j" :label="k.name" :value="k.id + ''"></el-option>
                </el-select>
              </template> -->
              <template v-if="v.wyFCode == 'noSelect'">
                <el-input v-model="v.wyDefaultValue" placeholder="请输入默认值"></el-input>
              </template>
              <template v-if="i==0">
                <a href="javascript:;" class="operation" @click="addFieldData(index)">添加</a>
              </template>
              <template v-else>
                <a href="javascript:;" class="operation" style="color:#FF4F4F" @click="delFieldData(index,i)">删除</a>
              </template>
            </el-form-item>
          </template>
        </el-form>
      </el-collapse-item>
    </el-collapse>
    <div class="button">
      <el-button type="primary" :disabled="loading" size="small" @click="submitForm('formFiled')">保存</el-button>
      <el-button type="primary" :disabled="loading" :loading="loading" @click="updateForm()">更新数据</el-button>
    </div>
  </div>
</template>
<script>
  import Api from '@/api/client/ec-basic-field'
  import {FIELD_CONDITION} from '@/models/ec-basic-field'
  export default {
    props: {
      origin: {
        type: String
      }
    },
    data () {
      return {
        loading: false,
        formFiled: [],
        optionsField: [],
        itemSelect: [],
        channelSelect: [],
        typeList: [
          {
            id: 1,
            name: '表单'
          },
          {
            id: 2,
            name: '智能聊天'
          }
        ]
      }
    },
    created () {
      if (this.origin === 'ec') {
        this.originType = 'ec'
      } else if (this.origin === 'lixiao') {
        this.originType = '励销'
      } else if (this.origin === 'xbb') {
        this.originType = '销帮帮'
      } else if (this.origin === 'huoban') {
        this.originType = '伙伴云'
      }
      this.getField()
      this.getItem()
      this.getChannels()
      this.getFieldSelect()
    },
    methods: {
      addFieldData (index) {
        const FIELD_CONDITION = {
          wyDefaultBooleanValue: false,
          wyDefaultValue: null,
          wyFChildCode: null,
          wyFChildName: null,
          wyFChildType: null,
          wyFCode: null,
          wyFName: null,
          wyFType: null,
          wyHasChild: false,
          wyUseDefault: false
        }
        const data = this.formFiled[index]
        data.wyFieldDataList.push(FIELD_CONDITION)
      },
      delFieldData (index, i) {
        let data = this.formFiled[index]
        data.wyFieldDataList.splice(i, 1)
      },
      getField () {
        const crmCode = {
          crmCode: this.origin
        }
        Api.getEcField(crmCode, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            const data = body.list
            this.formFiled = data
          } else {
            this.$message.error(body.error)
          }
        })
      },
      changeItemSelect (e, itemIndex, index) {
        const hasChild = this.formFiled[itemIndex].crmHasChild
        if (e !== '') {
          if (hasChild) {
            this.formFiled[itemIndex].crmChildDataList[index].wyFieldData.wyHasChild = true
          } else {
            this.formFiled[itemIndex].wyFieldDataList[index].wyHasChild = true
          }
        } else {
          if (hasChild) {
            this.formFiled[itemIndex].crmChildDataList[index].wyFieldData.wyHasChild = false
          } else {
            this.formFiled[itemIndex].wyFieldDataList[index].wyHasChild = false
          }
        }
      },
      changSelect (e, itemIndex, index) {
        const hasChild = this.formFiled[itemIndex].crmHasChild
        if (e === 'itemTitle' || e === 'channel' || e === 'resType') {
          this.optionsField.forEach(item => {
            if (item.code === e) {
              if (hasChild) {
                this.formFiled[itemIndex].crmChildDataList[index].wyFieldData.wyFChildType = item.childType
                this.formFiled[itemIndex].crmChildDataList[index].wyFieldData.wyUseDefault = false
                this.formFiled[itemIndex].crmChildDataList[index].wyFieldData.wyDefaultBooleanValue = false
                this.formFiled[itemIndex].crmChildDataList[index].wyFieldData.wyDefaultValue = ''
                // this.formFiled[itemIndex].crmChildDataList[index].wyFieldData.wyHasChild = true
              } else {
                this.formFiled[itemIndex].wyFieldDataList[index].wyFChildType = item.childType
                this.formFiled[itemIndex].wyFieldDataList[index].wyUseDefault = false
                this.formFiled[itemIndex].wyFieldDataList[index].wyDefaultBooleanValue = false
                this.formFiled[itemIndex].wyFieldDataList[index].wyDefaultValue = ''
                // this.formFiled[itemIndex].wyFieldDataList[index].wyHasChild = true
              }
            }
          })
        } else {
          if (hasChild) {
            this.formFiled[itemIndex].crmChildDataList[index].wyFieldData.wyFChildType = ''
            this.formFiled[itemIndex].crmChildDataList[index].wyFieldData.wyFChildCode = ''
            this.formFiled[itemIndex].crmChildDataList[index].wyFieldData.wyHasChild = false
            this.formFiled[itemIndex].crmChildDataList[index].wyFieldData.wyUseDefault = false
            this.formFiled[itemIndex].crmChildDataList[index].wyFieldData.wyDefaultBooleanValue = false
            this.formFiled[itemIndex].crmChildDataList[index].wyFieldData.wyDefaultValue = ''
          } else {
            this.formFiled[itemIndex].wyFieldDataList[index].wyFChildType = ''
            this.formFiled[itemIndex].wyFieldDataList[index].wyFChildCode = ''
            this.formFiled[itemIndex].wyFieldDataList[index].wyFChildType = false
            this.formFiled[itemIndex].wyFieldDataList[index].wyUseDefault = false
            this.formFiled[itemIndex].wyFieldDataList[index].wyDefaultBooleanValue = false
            this.formFiled[itemIndex].wyFieldDataList[index].wyDefaultValue = ''
          }
          if (e === 'noSelect') {
            if (hasChild) {
              this.formFiled[itemIndex].crmChildDataList[index].wyFieldData.wyUseDefault = true
            } else {
              this.formFiled[itemIndex].wyFieldDataList[index].wyUseDefault = true
            }
          }
        }
      },
      getFieldSelect () {
        Api.getEcFieldSelect(response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.optionsField = body.list
            this.optionsField.push({'name': '找不到选项', 'code': 'noSelect'})
          } else {
            this.$message.error(body.error)
          }
        })
      },
      updateForm () {
        const crmCode = {
          crmCode: this.origin
        }
        this.loading = true
        Api.UpdateEcField(crmCode, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.loading = false
            this.$message.success('更新成功')
            const data = body.list
            this.formFiled = data
          } else {
            this.$message.error(body.error)
          }
        })
      },
      submitForm (formName) {
        Api.saveEcField(this.formFiled, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.formFiled = body.list
            this.$message.success('保存成功！')
          } else {
            this.$message.error(body.error)
          }
        })
      },
      getItem () {
        Api.getItem(response => {
          let status = response.data.code
          let body = response.data.data
          if (status === '200') {
            this.itemSelect = body
          } else {
            this.$message.error(response.data.msg)
          }
        })
      },
      getChannels () {
        Api.getChannels(response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.channelSelect = body.list
          } else {
            this.$message.error(body.error)
          }
        })
      }
    }
  }
</script>

<style lang="scss">
.field-main .el-collapse{
  border-bottom:none;
}
.field-main .el-form-item__label{
  font-size: 14px;
  text-align: right!important;
  color:#888;
}
.field-main .el-collapse-item__header{
  padding-left:48px;
  color:#666;
  font-size: 16px;
  display: block;
  position: relative;
  height: 52px;
  line-height: 54px;
  i{
    position: absolute;
    left:180px;
    top:19px;
  }
}
.field-main .el-form-item__content{
  margin-left:300px!important;
}
.field-main .el-collapse-item__content{
  padding-bottom:10px;
}
.field-main .el-input__inner{
  height: 36px;
  line-height: 36px;
}
.field-main .el-form-item{
  margin-bottom: 10px;
}
.default{
  margin-left:10px;
  .el-checkbox__label{
    padding-left:5px;
  }
}
</style>

<style scoped lang="scss">
.field-main{
  margin-top:5px;
  .default{
    margin-left:10px;
    .el-checkbox__label{
      padding-left:5px;
    }
  }
  .operation{
    color:#409EFF;
    padding-left:5px;
  }
  .field-menu{
    padding-bottom:15px;
    span{
      display: inline-block;
      font-size:16px;
      font-weight:600;
      color:#666;
      &:nth-child(1){
        margin-left:48px;
      }
      &:nth-child(2){
        margin-left:120px;
      }
    }
  }
  .el-input{
    width:50%;
  }
  .button{
    text-align: center;
    margin-top:60px;
    button{
      // width:100px;
      height:35px;
      line-height:1;
      background:rgba(8,94,204,1);
      border-radius:4px;
      padding: 0 30px;
      font-size: 14px;
      &.el-button--update{
        background:#fff!important;
        border:2px solid #C4C4C4;
        color:#737373;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/crm/EcBasicField.vue